// API Response utilities for consistent handling across all APIs

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message: string;
  statusCode: number;
}

/**
 * Unwraps ApiResponse<T> to get the data property
 * Use this in transformResponse to extract data from backend responses
 */
export const unwrapApiResponse = <T>(response: ApiResponse<T>): T => response.data;

/**
 * Creates a transform response function for a specific type
 * Useful when you need type-specific handling
 */
export const createApiResponseTransformer = <T>() => 
  (response: ApiResponse<T>): T => response.data;